/**
 * reviewnotesreducer.js
 * Created by calhosh on 11/10/2020.
 */
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {
	HttpStatusCodes,
	reviewNoteStatus,
	reviewNoteStatusFilter,
	updateAnnotationAction
} from "../../util/uiconstants";
import _ from 'lodash';

export default function reviewNotesReducer(state = initialState.reviewNotes, action) {
	switch (action.type) {
		case types.GET_REVIEW_NOTES:
			return action.response || state;
		case types.CLEAR_REVIEW_NOTES:
			return {};
		case types.DELETE_NOTE: {
			if (action.returnCurrentState) return state;

			let clonedState = JSON.parse(JSON.stringify(state));
			if(action.noteIds){
				for (let i = 0; i < action.noteIds.length; i++) {
					clonedState = deleteAnnotation(clonedState, action.noteIds[i], action.hasGroups);
				}
			}else{
				clonedState = deleteAnnotation(clonedState, action.noteId, action.hasGroups);
			}

			return clonedState;
		}
		case types.ADD_NOTE: {
			if (!state || !state.annotations) return state;

			let newState = JSON.parse(JSON.stringify(state));
			/*newState.isOpen = true;*/
			/*let entityIndex = newState.annotations.findIndex(
				(noteGroup) => noteGroup.entityUID === action.noteInfo.entityUID
			);
*/
			newState.allOpenReviewNotesCount++;
			newState.documentOpenReviewNoteCount++;
			if (
				action.noteInfo.currentUser === action.noteInfo.fromUser ||
				action.noteInfo.currentUser === action.noteInfo.toUser
			) {
				newState.myOpenReviewNotesCount++;
			}
			newState.annotations.push(
				{
					annotationTypeId: action.noteInfo.annotationTypeId,
					assignedToUserName: action.noteInfo.toUserName,
					priorityTypeId: action.noteInfo.priorityTypeId,
					createUserName: action.noteInfo.fromUserName,
					assignedToUserId: action.noteInfo.toUser,
					createUserId: action.noteInfo.fromUser,
					entityUID: action.noteInfo.entityUID,
					entityID: action.noteInfo.entityID,
					dueDate: action.noteInfo.dueDate,
					text: action.noteInfo.comments,
					id: action.responseObj.data.id,
					statusId: action.responseObj.data.statusId,
					createDate: action.responseObj.data.createDate,
					modifiedDate: action.responseObj.data.createDate,
					referenceNumber: action.responseObj.data.referenceNumber,
					editable: action.noteInfo.currentUser === action.noteInfo.fromUser
				}
			);
			return newState;
		}
		case types.UPDATE_NOTE_INFO: {
			const userId = action.data.toUser;
			const userName = action.data.userFullName;
			const priorityTypeId = action.data.priorityTypeId;
			const annotationStatusId = action.data.annotationStatusId;
			const dueDate = action.data.dueDate;
			const modifiedDate = action.data.modifiedDate;

			let newState = JSON.parse(JSON.stringify(state));
			/*newState.isOpen = true;*/
			let element = _.find(newState.annotations, (a) => a.id === action.selectedNoteId);

			if (element) {
				if (userId) {
					element.assignedToUserId = userId;
					element.assignedToUserName = userName;
				}
				if (priorityTypeId) {
					element.priorityTypeId = priorityTypeId;
				}
				if (annotationStatusId) {
					element.statusId = annotationStatusId;
				}
				if (dueDate) {
					element.dueDate = dueDate;
				}
				element.modifiedDate = modifiedDate;
			}
			return newState;
		}
		case types.UPDATE_NOTE_DETAIL: {
			if (!state || !state.annotations) return state;

			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let newState = JSON.parse(JSON.stringify(state));
				let note, oldStatus;
				if (action.data.updateAction === updateAnnotationAction.editReply) {
					// find parent note and update modified date
					let parentNote;
					newState.annotations.every((a) => {
						note = a.replies ? a.replies.find((r) => r.id === action.noteId) : null;
						if (note) {
							parentNote = a;
							return false;
						}
						return true;
					});

					updateNoteData(parentNote, {});
				} else {
					note = newState.annotations.find((a) => a.id === action.noteId);
					oldStatus = note.statusId;
				}

				updateNoteData(note, action.data);

				if (action.data.annotationStatusId) {
					switch (note.statusId) {
						case reviewNoteStatusFilter.Open:
						{
							newState.allOpenReviewNotesCount++;
							if (action.currentUser === note.createUserId || action.currentUser === note.assignedToUserId) {
								newState.myOpenReviewNotesCount++;
							}
						}
							break;
						case reviewNoteStatusFilter.Closed:
						case reviewNoteStatusFilter.Cleared:
						{
							if (oldStatus !== reviewNoteStatusFilter.Cleared) {
								newState.allOpenReviewNotesCount--;
								if (action.currentUser === note.createUserId || action.currentUser === note.assignedToUserId) {
									newState.myOpenReviewNotesCount--;
								}
							}
						}
							break;
						default:
							break;
					}
				}

				return newState;
			} else if (action.error.response.status === HttpStatusCodes.NotFound) {
				let newState = JSON.parse(JSON.stringify(state));
				newState.parentWasDeleted = true;

				return newState;
			}

			return state;
		}
		case types.POST_NOTE_REPLY: {
			if (!state || !state.annotations) return state;

			if (action.responseObj.status === HttpStatusCodes.Created) {
				let newState = JSON.parse(JSON.stringify(state));
				let parentNote = action.response.parentAnnotation;
				let element = newState.annotations.find((n) => n.id === parentNote.id);

				// update parent note with new values
				if (parentNote.fromUser) {
					element.createUserId = parentNote.fromUser;
				}
				if (parentNote.fromUserName) {
					element.createUserName = parentNote.fromUserName;
				}
				if (parentNote.dueDate) {
					element.dueDate = parentNote.dueDate;
				}
				if (parentNote.toUser) {
					element.assignedToUserId = parentNote.toUser;
				}
				if (parentNote.toUserName) {
					element.assignedToUserName = parentNote.toUserName;
				}
				if (parentNote.statusId) {
					element.statusId = parentNote.statusId;
				}
				if (parentNote.modifiedDate) {
					element.modifiedDate = parentNote.modifiedDate;
				}
				if (parentNote.priorityTypeId) {
					element.priorityTypeId = parentNote.priorityTypeId;
				}

				// add new reply to array
				const reply = {
					author: action.response.createUserName,
					authorUserID: action.response.createUserId,
					id: action.response.id,
					isCreatorSelf: true,
					modifiedDate: action.response.createDate,
					parentId: parentNote.id,
					text: action.response.text
				};

				element.isOpen = true;

				if (_.isArray(element.replies)) {
					element.replies.push(reply);
				} else {
					element.replies = [reply];
				}

				element.replyCount = element.replies.length;

				return newState;
			}

			return state;
		}
		case types.DELETE_NOTE_DETAIL: {
			if (!state || !state.annotations) return state;

			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				let newState = JSON.parse(JSON.stringify(state));
				// find parent note and update modified date
				let parentNote;
				newState.annotations.every((a) => {
					let reply = a.replies ? a.replies.find((r) => r.id === action.data.noteIds[0]) : null;
					if (reply) {
						_.remove(a.replies, (r) => {
							return r.id === action.data.noteIds[0];
						});
						parentNote = a;
						/*parentNote.isOpen = true;*/
						parentNote.modifiedDate = action.data.modifiedDate;
						parentNote.replyCount--;
						return false;
					} else if (a.id === action.data.noteIds[0]) {
						newState.parentWasDeleted = true;
					}
					return true;
				});
				return newState;
			} else if (action.error.response.status === HttpStatusCodes.Conflict) {
				// Bifurcation only for concurrency scenario when another user changes open status from parent note.
				return state;
			} else if (action.error.response.status === HttpStatusCodes.NotFound) {
				// Bifurcation only for concurrency scenario when another user deletes parent note.
				let newState = JSON.parse(JSON.stringify(state));
				newState.parentWasDeleted = true;
				return newState;
			}
			return state;
		}
		case types.EXPAND_COLLAPSE_NOTE:{
			const noteId = action.noteId;
			const isOpen = action.isOpen;
			let newState = JSON.parse(JSON.stringify(state));
			let element = _.find(newState.annotations, (a) => a.id === noteId);

			if (element) {
				element.isOpen = isOpen;
			}
			return  newState;
		}
		default:
			return state;
	}
}


const getAnnotation = (newState, noteId, hasGroups) => {
	let element;
	if (newState && newState.annotations) {
		if (hasGroups) {
			newState.annotations.every((a) => {
				element = a.responses.find((r) => r.id === noteId);
				if (element) {
					return false;
				}
				return true;
			});
		} else {
			element = newState.annotations.find((a) => {
				return a.id === noteId;
			});
		}
	}

	return element;
};

const deleteAnnotation = (newState, annotationId, hasGroups) => {
	let element = getAnnotation(newState, annotationId, hasGroups);
	if (element) {
		switch (element.statusId) {
			case reviewNoteStatus.Open.id:
				newState.allOpenReviewNotesCount--;
				newState.documentOpenReviewNoteCount--;
				break;
			case reviewNoteStatus.Closed.id:
				newState.allClosedReviewNotesCount--;
				newState.documentOpenReviewNoteCount--;
				break;
			case reviewNoteStatus.Cleared.id:
				newState.allClearedReviewNotesCount--;
				newState.documentOpenReviewNoteCount--;
				break;
			default:
				break;
		}

		let removedElement = [];
		if (hasGroups) {
			let parent = _.find(newState.annotations, (a) => {
				return a.entityUID === element.entityUID;
			});
			removedElement = parent.responses
				? _.remove(parent.responses, (r) => {
					return r.id === annotationId;
				})
				: [];

			if (_.isEmpty(parent.responses)) {
				_.remove(newState.annotations, (a) => {
					return a.id === parent.id;
				});
			}
		} else {
			removedElement = _.remove(newState.annotations, (a) => {
				return a.id === annotationId;
			});
		}
		if (!_.isEmpty(removedElement)) newState.totalReviewNotesCount--;
	}

	return newState;
};


const updateNoteData = (note, data) => {
	if (note) {
		if (data.toUser) {
			note.assignedToUserId = data.toUser;
			note.assignedToUserName = data.toUserName;
		}
		if (data.priorityTypeId) {
			note.priorityTypeId = data.priorityTypeId;
		}
		if (data.annotationStatusId) {
			note.statusId = data.annotationStatusId;
		}
		if (data.dueDate) {
			note.dueDate = data.dueDate;
		}
		if (data.comments) {
			note.text = data.comments;
		}
		if (data.statusChangeUserName) {
			note.statusChangeUserName = data.statusChangeUserName;
			note.statusChangeDate = new Date().toISOString();
		}

		/*note.isOpen = true;*/
		note.modifiedDate = data.modifiedDate || new Date().toISOString();
	}
};
